<rt-dialog-header
  [heading]="'app.requisitions.duplicate_dialog.heading' | translate"
  [subheading]="'app.requisitions.duplicate_dialog.subheading' | translate"
  ><span class="step">{{ 'app.requisitions.create_dialog.step_2_of_2' | translate }}</span>
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  <rt-box variant="default no-padding" padding-top-medium layout-vertical>
    <div class="top-wrap">
      <ng-container *ngTemplateOutlet="top"></ng-container>
    </div>
    @if (visibleItems.length) {
      <rt-divider></rt-divider>
    }
    <ng-container *ngTemplateOutlet="visibleItems.length ? list : emptyState"></ng-container>
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button class="optional" (click)="goBack()" variant="plain">
    <rt-icon name="arrow-back"></rt-icon>
    {{ 'app.common.go_back' | translate }}
  </rt-button>
  <rt-button [disabled]="saving" (click)="cancel()" variant="plain">{{
    'app.common.cancel' | translate
  }}</rt-button>
  <rt-button
    [disabled]="!selectedId || saving"
    [loading]="saving"
    (click)="save()"
    variant="primary"
    >{{ 'app.common.duplicate' | translate }}</rt-button
  >
</rt-dialog-footer>

<ng-template #list>
  <div class="scroll-wrap">
    @for (item of visibleItems; track trackById($index, item); let last = $last) {
      <div (click)="selectItem(item.id)" class="item">
        <rt-radio
          [checked]="selectedId === item.id"
          (click)="$event.stopPropagation(); selectItem(item.id)"
        >
          <div class="title-badges">
            <span class="title">{{ item.title }}</span>
            <rt-requisitions-status-badge [status]="item.status"></rt-requisitions-status-badge>
            <rt-badge class="transform-none" color="secondary" [text]="'#' + item.guid"></rt-badge>
          </div>
          <div class="description">
            <ng-container
              *ngTemplateOutlet="
                description;
                context: {
                  item: item,
                  hasDepartmentTooltip: departmentTooltipEnabledMap[item.id]
                }
              "
            ></ng-container>
          </div>
        </rt-radio>
      </div>
      @if (!last) {
        <rt-divider></rt-divider>
      }
    }
  </div>
</ng-template>

<ng-template #top>
  <rt-form-field>
    <rt-input
      [formControl]="queryControl"
      [hasClearButton]="true"
      (reset)="queryControl.setValue('')"
      [placeholder]="'app.requisitions.duplicate_dialog.search_placeholder' | translate"
    >
      <rt-icon prefix name="search"></rt-icon>
    </rt-input>
  </rt-form-field>
  @if (visibleItems.length) {
    <div class="list-heading">
      <span>{{ 'app.requisitions.duplicate_dialog.list_heading' | translate }}</span
      ><rt-badge color="counter-default" [text]="visibleItems.length"></rt-badge>
      <ng-container *ngTemplateOutlet="sort"></ng-container>
    </div>
  }
</ng-template>

<ng-template #description let-item="item" let-hasDepartmentTooltip="hasDepartmentTooltip">
  @if (item.departmentName) {
    <div
      #departmentRef
      [rtTooltip]="item.departmentName"
      [rtTooltipPosition]="'below'"
      [rtTooltipEnabled]="hasDepartmentTooltip"
      [class.restricted]="item.locationText"
      [attr.data-requisition-id]="item.id"
      class="description-item department"
    >
      {{ item.departmentName }}
    </div>
  }
  @if (item.locationText) {
    @if (item.departmentName) {
      <rt-divider variant="dot"></rt-divider>
    }
    @if (item.locationIds?.length) {
      <rt-assigned-locations-info-container
        [locationIds]="item.locationIds"
        [attr.data-requisition-id]="item.id"
      ></rt-assigned-locations-info-container>
    } @else {
      <span>{{ item.locationText }}</span>
    }
  }
  @if (item.jobOpeningsText) {
    @if (item.departmentName || item.locationText) {
      <rt-divider variant="dot"></rt-divider>
    }
    <div class="description-item job-openings-text">
      {{ item.jobOpeningsText }}
    </div>
  }
</ng-template>

<ng-template #sort>
  <rt-button
    rt-overlay-origin
    #sortDropdownTrigger="rtOverlayOrigin"
    [dropdownOpened]="sortDropdownOpen"
    (click)="toggleSortDropdown()"
    variant="plain"
    size="small"
  >
    <rt-icon name="sort"></rt-icon>
    {{ sortByLabels[sortBy] }}</rt-button
  >
  <ng-template
    #sortDropdownTpl
    rt-connected-overlay
    [origin]="sortDropdownTrigger"
    [hasBackdrop]="true"
    [open]="sortDropdownOpen"
    (backdropClick)="toggleSortDropdown(false)"
  >
    <rt-dropdown (click)="$event.stopPropagation()">
      <rt-dropdown-header [fullWidthTitle]="true">{{
        'app.offers.sort_by.dropdown_title' | translate
      }}</rt-dropdown-header>
      <rt-dropdown-item (click)="setSortBy('statusName'); toggleSortDropdown(false)">{{
        sortByLabels.statusName
      }}</rt-dropdown-item>
      <rt-dropdown-item (click)="setSortBy('title'); toggleSortDropdown(false)">
        {{ sortByLabels.title }}</rt-dropdown-item
      >
    </rt-dropdown>
  </ng-template>
</ng-template>

<ng-template #emptyState>
  <rt-empty-state
    variant="small"
    [icon]="'error-outline'"
    [title]="'app.common.no_results_found' | translate"
    padding-tb
  >
    <rt-button variant="tertiary" (click)="queryControl.setValue('')">{{
      'app.common.clear_search' | translate
    }}</rt-button>
  </rt-empty-state>
</ng-template>
